import { makeStyles } from '@material-ui/styles'

const styles = makeStyles(theme => ({
  pepData: {
    display: 'flex',
    flexDirection: 'column',
  },
  pepDataItem: {
    display: 'flex',
    marginBottom: 5,
  },
}))

export default styles
